{
  "articles": {
    "title": "Articles",
    "description": "Parcourez les articles éducatifs et les ressources",
    "search": {
      "placeholder": "Rechercher des articles...",
      "noResults": "Aucun article trouvé",
      "tryDifferent": "Essayez un terme de recherche différent"
    },
    "empty": {
      "title": "Aucun article disponible",
      "description": "Il n'y a aucun article à afficher pour le moment"
    },
    "readMore": "Lire la suite",
    "details": {
      "title": "Détails de l'article",
      "description": "Lire l'article complet",
      "back": "Retour",
      "backToArticles": "Retour aux articles",
      "updated": "Mis à jour",
      "notFound": "Article non trouvé",
      "notFoundDescription": "L'article que vous recherchez n'existe pas ou a été supprimé",
      "noContent": "Aucun contenu disponible pour cet article"
    }
  },
  "videos": {
    "title": "Vidéos",
    "description": "Regardez des vidéos éducatives et des tutoriels",
    "search": {
      "placeholder": "Rechercher des vidéos...",
      "noResults": "Aucune vidéo trouvée",
      "tryDifferent": "Essayez un terme de recherche différent"
    },
    "empty": {
      "title": "Aucune vidéo disponible",
      "description": "Il n'y a aucune vidéo à afficher pour le moment"
    },
    "watch": "Regarder",
    "details": {
      "title": "Détails de la vidéo",
      "description": "Regarder la vidéo complète",
      "back": "Retour",
      "backToVideos": "Retour aux vidéos",
      "updated": "Mis à jour",
      "notFound": "Vidéo non trouvée",
      "notFoundDescription": "La vidéo que vous recherchez n'existe pas ou a été supprimée",
      "noVideo": "Aucune vidéo disponible",
      "learningObjectives": "Objectifs d'apprentissage",
      "prerequisites": "Prérequis"
    }
  },
  "trainings": {
    "title": "Formations",
    "description": "Accédez aux matériels de formation et aux cours",
    "search": {
      "placeholder": "Rechercher des formations...",
      "noResults": "Aucune formation trouvée",
      "tryDifferent": "Essayez un terme de recherche différent"
    },
    "empty": {
      "title": "Aucune formation disponible",
      "description": "Il n'y a aucune formation à afficher pour le moment"
    },
    "start": "Commencer",
    "details": {
      "title": "Détails de la formation",
      "description": "Voir le contenu complet de la formation",
      "back": "Retour",
      "backToTrainings": "Retour aux formations",
      "updated": "Mis à jour",
      "notFound": "Formation non trouvée",
      "notFoundDescription": "La formation que vous recherchez n'existe pas ou a été supprimée",
      "noContent": "Aucun contenu disponible pour cette formation"
    }
  },
  "admin": {
    "title": "Gestion des médias",
    "description": "Gérer les articles, vidéos et contenus de formation",
    "overview": {
      "articles": {
        "title": "Articles",
        "description": "Gérer les articles de blog et le contenu",
        "counter": "{{counter}} articles",
        "manage": "Gérer les articles"
      },
      "videos": {
        "title": "Vidéos",
        "description": "Gérer les vidéos éducatives",
        "counter": "{{counter}} vidéos",
        "manage": "Gérer les vidéos"
      },
      "trainings": {
        "title": "Formations",
        "description": "Gérer le contenu de formation",
        "counter": "{{counter}} formations",
        "manage": "Gérer les formations"
      },
      "recentActivity": {
        "title": "Activité récente",
        "description": "Dernières mises à jour du contenu"
      },
      "statistics": {
        "title": "Statistiques du contenu",
        "description": "Aperçu de votre bibliothèque de contenu",
        "totalContent": "Contenu total",
        "publishedArticles": "Articles publiés",
        "draftArticles": "Articles en brouillon"
      }
    },
    "articles": {
      "title": "Articles",
      "description": "Créer et gérer les articles de blog",
      "addTitle": "Créer un nouvel article",
      "addDescription": "Ajouter un nouvel article à votre bibliothèque de contenu",
      "editTitle": "Modifier l'article",
      "editDescription": "Mettre à jour les informations de l'article",
      "deleteTitle": "Supprimer l'article",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer cet article ? Cette action est irréversible.",
      "form": {
        "title": "Titre",
        "titlePlaceholder": "Entrez le titre de l'article",
        "description": "Description",
        "descriptionPlaceholder": "Entrez la description de l'article",
        "content": "Contenu",
        "contentPlaceholder": "Rédigez le contenu de votre article ici...",
        "image": "Image à la une",
        "imagePlaceholder": "Télécharger l'image à la une",
        "isPublished": "Publié",
        "isPublishedDescription": "Rendre cet article visible aux utilisateurs"
      },
      "table": {
        "title": "Titre",
        "description": "Description",
        "status": "Statut",
        "createdAt": "Créé le",
        "actions": "Actions"
      },
      "status": {
        "published": "Publié",
        "draft": "Brouillon"
      }
    },
    "videos": {
      "title": "Vidéos",
      "description": "Créer et gérer les vidéos éducatives",
      "addTitle": "Créer une nouvelle vidéo",
      "addDescription": "Ajouter une nouvelle vidéo à votre bibliothèque de contenu",
      "editTitle": "Modifier la vidéo",
      "editDescription": "Mettre à jour les informations de la vidéo",
      "deleteTitle": "Supprimer la vidéo",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer cette vidéo ? Cette action est irréversible.",
      "form": {
        "title": "Titre",
        "titlePlaceholder": "Entrez le titre de la vidéo",
        "description": "Description",
        "descriptionPlaceholder": "Entrez la description de la vidéo",
        "content": "Contenu",
        "contentPlaceholder": "Rédigez le contenu de la vidéo ici...",
        "duration": "Durée",
        "durationPlaceholder": "ex. : 15:30",
        "videoUrl": "URL de la vidéo",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=...",
        "learningObjectives": "Objectifs d'apprentissage",
        "learningObjectivesPlaceholder": "Qu'apprendront les utilisateurs en regardant cette vidéo ?",
        "prerequisites": "Prérequis",
        "prerequisitesPlaceholder": "Que doivent savoir les utilisateurs avant de regarder ?",
        "image": "Image miniature",
        "imagePlaceholder": "Télécharger la miniature de la vidéo"
      },
      "table": {
        "title": "Titre",
        "description": "Description",
        "duration": "Durée",
        "createdAt": "Créé le",
        "actions": "Actions"
      }
    },
    "trainings": {
      "title": "Formations",
      "description": "Créer et gérer le contenu de formation",
      "addTitle": "Créer une nouvelle formation",
      "addDescription": "Ajouter une nouvelle formation à votre bibliothèque de contenu",
      "editTitle": "Modifier la formation",
      "editDescription": "Mettre à jour les informations de la formation",
      "deleteTitle": "Supprimer la formation",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer cette formation ? Cette action est irréversible.",
      "form": {
        "title": "Titre",
        "titlePlaceholder": "Entrez le titre de la formation",
        "description": "Description",
        "descriptionPlaceholder": "Entrez la description de la formation",
        "content": "Contenu",
        "contentPlaceholder": "Rédigez le contenu de votre formation ici...",
        "duration": "Durée",
        "durationPlaceholder": "ex. : 2 heures",
        "videoUrl": "URL de la vidéo",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=...",
        "image": "Image à la une",
        "imagePlaceholder": "Télécharger l'image de la formation"
      },
      "table": {
        "title": "Titre",
        "description": "Description",
        "duration": "Durée",
        "createdAt": "Créé le",
        "actions": "Actions"
      }
    },
    "common": {
      "create": "Créer",
      "creating": "Création...",
      "update": "Mettre à jour",
      "updating": "Mise à jour...",
      "delete": "Supprimer",
      "deleting": "Suppression...",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "edit": "Modifier",
      "view": "Voir",
      "noResults": "Aucun résultat trouvé",
      "loading": "Chargement...",
      "error": "Une erreur est survenue",
      "success": "Succès",
      "confirmDelete": "Êtes-vous sûr ?",
      "search": "Rechercher...",
      "filter": "Filtrer",
      "sort": "Trier",
      "actions": "Actions",
      "openMenu": "Ouvrir le menu"
    }
  },
  "success": {
    "createArticleSuccess": "Article créé avec succès",
    "updateArticleSuccess": "Article mis à jour avec succès",
    "deleteArticleSuccess": "Article supprimé avec succès",
    "createVideoSuccess": "Vidéo créée avec succès",
    "updateVideoSuccess": "Vidéo mise à jour avec succès",
    "deleteVideoSuccess": "Vidéo supprimée avec succès",
    "createTrainingSuccess": "Formation créée avec succès",
    "updateTrainingSuccess": "Formation mise à jour avec succès",
    "deleteTrainingSuccess": "Formation supprimée avec succès"
  },
  "errors": {
    "createArticleFailed": "Échec de la création de l'article",
    "createTrainingFailed": "Échec de la création de la formation",
    "createVideoFailed": "Échec de la création de la vidéo",
    "deleteArticleFailed": "Échec de la suppression de l'article",
    "deleteTrainingFailed": "Échec de la suppression de la formation",
    "deleteVideoFailed": "Échec de la suppression de la vidéo",
    "loadArticlesFailed": "Échec du chargement des articles",
    "loadTrainingsFailed": "Échec du chargement des formations",
    "loadVideosFailed": "Échec du chargement des vidéos",
    "updateArticleFailed": "Échec de la mise à jour de l'article",
    "updateTrainingFailed": "Échec de la mise à jour de la formation",
    "updateVideoFailed": "Échec de la mise à jour de la vidéo"
  }
}
